import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export interface RequireLinkedOperatorProps {
  redirectTo?: string;
  children: React.ReactNode;
}

/**
 * RequireLinkedOperator
 *
 * Gates a route on the caller having a SprayOperator record linked to their
 * user account. Reads `hasLinkedOperator` from the auth context (set at
 * /me time); no async work, no extra round trip.
 *
 * FarmAdmin and superadmin always pass through regardless of linkage.
 *
 * On deny: redirects to `/forbidden` (override via `redirectTo`).
 */
export function RequireLinkedOperator({ redirectTo = '/forbidden', children }: RequireLinkedOperatorProps) {
  const { user } = useAuth();
  if (!user) return <Navigate to={redirectTo} replace />;
  if (user.superadmin) return <>{children}</>;
  if (user.role?.isFarmAdministrator) return <>{children}</>;
  if (user.hasLinkedOperator === true) return <>{children}</>;
  return <Navigate to={redirectTo} replace />;
}
